import { DatePipe } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, GridComponent, PageSettingsModel, QueryCellInfoEventArgs, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfigurationService } from 'src/app/configuration.service';
import { GlobalComponent } from 'src/app/global/global.component';
import {columnWidth } from '../employee/employee.model';
import { OperationalDashboardService } from '../operational-dashboard/operational-dashboard.service';
import { ColumnChangeBO, functionpermission, GetListBO, ImportreturnBO, WhereCondition } from './import-payment.model';
import { ImportService } from './import-payment.service';
import * as pbi from "powerbi-client";
import { GetHTTPImportService } from './import-paymentlist.service';

declare var $: any;

@Component({
  selector: 'app-import-payment',
  templateUrl: './import-payment.component.html',
  styleUrls: ['./import-payment.component.scss']
})
export class ImportPaymentComponent implements OnInit {
  /////////////// Grid Initializations////////////////
  private onDestroy$: Subject<void> = new Subject<void>();
  public transcMenuFilterettings: object;
  @ViewChild('pdflist') pdflist;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  public filterSettings: object;
  @ViewChild("grid") public grid: GridComponent;
  @ViewChild("reportContainer", { static: false }) reportContainer: ElementRef;
/////////////////////////////
public formatOptions: object;
   fileToUpload: any = "";
   selectedFileName: any = "";
   filepath: string;
   onDOCFileChangedErr: any = ""
   Report835: any;
   viewFiles: boolean = false
   Importreturn:ImportreturnBO=new ImportreturnBO()
   public data: Observable<DataStateChangeEventArgs>;
   ListSendBO: GetListBO = new GetListBO();
   ImportDataList: any = [];
   arraycol: any = [];
   ColumnArray: columnWidth[]
   id:string="00000000-0000-0000-0000-000000000000";
   columnchange: ColumnChangeBO = new ColumnChangeBO();
   conditionlist: WhereCondition[] = [];
   getErr: any = "";
   TotalCount: number;
   public wrapSettings: TextWrapSettingsModel;
   companydetails:any;
   payorDetail:any;
   paymentDetail:any;
   Token:string='';
   Reportcontain:boolean=false;
   configuration:any;
   patientClaimDetails:any;
   IsButtonDisable: boolean = false;
  constructor( public global: GlobalComponent,public datePipe: DatePipe,
    private operationalDashboardService:OperationalDashboardService,
    public configurationservice: ConfigurationService,
    public toasterservice: ToastrService,public http: HttpClient,public httpService: ImportService, public gethttp: GetHTTPImportService, private ref: ChangeDetectorRef) {
   this.data=this.gethttp;
   this.configuration = this.configurationservice.getConfiguration();
   }
   fp:functionpermission=new functionpermission()
  ngOnInit(): void {
    this.initialPage = {
      currentPage: 1,
      totalRecordsCount: 0,
      pageCount: 10,
      pageSize: this.pageSizes[5],
      pageSizes: this.pageSizes,
    };
    this.wrapSettings = { wrapMode: 'Content' };
    this.formatOptions = { type: "date", format: "MM/dd/yyyy" };
    this.filterSettings = {
      type: "Menu",
    };
    this.getImportFilter()
    this.getpermission()
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "ImportPayments");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  ////////////////////////////// File uPload /////////////////////////////////////
 
  onFileChanged(file) {
    console.log(file,"file")
    this.fileToUpload = file.item(0);
    this.selectedFileName = file.item(0).name;
  }


  ////////////////////////////// Save importFile/////////////////////////////////////

  onDOCFileChanged() {
    this.IsButtonDisable = true;
    this.Importreturn.fileName = this.fileToUpload.name
    this.selectedFileName = this.fileToUpload.name;
    let body = new FormData();
    body.append('Filepath', this.fileToUpload);
    body.append('agency', this.global.globalAgencyId.toString());
    let url = "api/Import/Import835file";
    this.http.post(url, body).pipe(takeUntil(this.onDestroy$)).subscribe(
      (data: any) => {
        this.IsButtonDisable = false;
        this.Report835 = data.invoice;
        this.filepath=''
        this.toasterservice.success(
          "File will be imported shortly",
          "File imported",
        ), 8000
        this.getImportFilter()


      },
      (err: any) => {
        this.IsButtonDisable = false;
        console.log(err,"ee")
        this.toasterservice.error(
          err.error
        ), 1000
      
      }
    );
  }



      ////////////////////////////// Show Column Chooser /////////////////////////////////////
  show() {
    this.grid.columnChooserModule.openColumnChooser(200, 50);
  }
  //////////////////////////////Get Import  Array with Filters /////////////////////////////////////
  getImportFilter() {
    this.ListSendBO.agencyID = this.global.globalAgencyId;
    this.gethttp.execute(this.ListSendBO);
    let count = 0
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ImportDataList=data.result;
      count = count + 1
      if (data != null && data != undefined && count == 1) {
      }
      if (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000') {
      if (data != null && data.result.length > 15) {
        this.grid.height = '500';
      }
      else {
        this.grid.height = 'auto';
      }
    }
    })
  }


    //============================ tooltip For header ===================================//
  //============================== Tooltip =========================================================//
  headerCellInfo(args) {

    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);

  }
  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',


        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  onResize(args) {

    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }

    });
  }

    ////////////////////////////// Action Complete Functionn /////////////////////////////////////
    public onActionComplete(args) {

      if (args.requestType == "columnstate") {
        let hidearr = [];
        let showarr = [];
        this.grid.columns.forEach(element => {
          if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
            hidearr.push(element.headerText);
          }
          if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
            showarr.push(element.headerText);
          }
        })
  
        var count = 0;
        var count1 = 0;
        if (args.columns.length > 0) {
          if (this.arraycol.length > 0) {
            this.arraycol[0].Import.ShowColumns.forEach(old => {
              showarr.forEach(element => {
                if (old == element) {
                  count1 = count1 + 1;
                }
              });
  
            });
  
            this.arraycol[0].Import.HideColumns.forEach(old => {
              hidearr.forEach(element => {
                if (old == element) {
                  count = count + 1;
                }
              });
  
            });
  
  
            if (this.arraycol[0].Import.ShowColumns.length != count1 || this.arraycol[0].Import.HideColumns.length != count) {
              this.arraycol[0].Import.ShowColumns = showarr;
              this.arraycol[0].Import.HideColumns = hidearr;
            }
          }
  
        }
      }
      this.ListSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
      this.ListSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
      this.conditionlist = [];
      if (args.requestType === "filtering" && args.action === "filter") {
        args.columns.forEach(element => {
          this.conditionlist.push(element.properties);
        });
      }
      if (args.name == "actionBegin" && args.requestType == "filterbeforeopen") {
        this.ListSendBO.type = args.columnType
      }
  
    }

    type: string = "";
    public dataStateChange(state): void {
      this.type = (state.action.requestType).toString();
      if (this.type != "filterchoicerequest") {
        if ((state.sorted || []).length) {
          this.ListSendBO.orderColumn = state.sorted[0].name;
          this.ListSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
        }
      }
      if (this.type == "filtering" && state.action.action != "clearFilter") {
        if (this.ListSendBO.type == "date") {
  
          this.ListSendBO.value = (new Date(new Date(state.action.currentFilterObject.value).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
        }
        else {
          this.ListSendBO.value = state.action.currentFilterObject.value.toString();
        }
        this.ListSendBO.field = state.action.currentFilterObject.field;
        this.ListSendBO.matchCase = state.action.currentFilterObject.matchCase;
        this.ListSendBO.operator = state.action.currentFilterObject.operator;
  
      }
      else {
        if (this.type == "filtering" && state.action.action == "clearFilter") {
          this.ListSendBO.field = "fileName";
          this.ListSendBO.matchCase = false;
          this.ListSendBO.operator = "startswith";
          this.ListSendBO.value = "";
          this.ListSendBO.type = "string";
        }
      }
      if(state.action.action == "filter" && this.ListSendBO.value == "" 
        || this.ListSendBO.value == undefined || this.ListSendBO.value == null){
          this.ListSendBO.field = "fileName";
          this.ListSendBO.matchCase = false;
          this.ListSendBO.operator = "startswith";
          this.ListSendBO.value = "";
          this.ListSendBO.type = "string";
        }
      this.ListSendBO.agencyID =this.global.globalAgencyId;
      this.getImportFilter();
      if (this.type == "paging" && state.action.name == "actionBegin") {
        if (this.arraycol.length != 0) {
          if (this.arraycol[0].Import.Pagesize != state.take) {
            this.arraycol[0].Import.Pagesize = state.take
  
          }
  
        }
      }
    }


 

  Refresh() {
    this.fileToUpload = '';
    this.selectedFileName = '';
    this.ListSendBO.field = 'fileName';
    this.ListSendBO.type = 'string'
    this.ListSendBO.value = '';
    this.filepath=''
    this.ListSendBO.currentpageno = 1;
    
    this.grid.clearFiltering();
    this.grid.clearSorting();
    this.getImportFilter();

  }
  
    ////////////////////////////// Download /////////////////////////////////////
    downloadImportFile(file) {
      if (file != null) {
        window.open(file);
      }
  
    }


    //////////////////////////////////////////////token\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


    gettoken() {
      return new Promise((resolve, rejects) => {
        this.httpService
          .getpowerbiToken()
          .pipe(takeUntil(this.onDestroy$))
          .subscribe(
            (data: any) => {
              this.Token = data;
              resolve(data);
            },
            (error: any) => {
              resolve(error.message);
            }
          );
      });
    }

  downloadClaimFile(ViewBatchfile) {
    var FileSaver = require("file-saver");
    let blob = new Blob([ViewBatchfile._ediString], {
      type: "text/plain;charset=utf-8",
    });
    FileSaver.saveAs(blob, ViewBatchfile.fileName);
  }

  getclaimID(claimId) {
    let params = new URLSearchParams();
    params.append("EDI835Id", claimId);
    this.httpService
      .getBatchFileTstring(params)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data) => {
        this.downloadClaimFile(JSON.parse(data));
      });
  }

  closemodal(){
      document.getElementById('openReportModal').click();
      this.Reportcontain = false;
    }

   //-------------------------------------------------- REPORT  -----------------------------------------------------------//

   ShowReport(value) {
    let currentTime = this.datePipe.transform(new Date(), "MM/dd/yyyy hh:mm a");
    this.Reportcontain = true;
    this.gettoken().then((token) => {
      document.getElementById("openReportModal").click();

      let embedUrl =
        "https://app.powerbi.com/rdlEmbed?reportId=" +
        this.configuration.reportId835 +
       "&rp:FileId=" +
        value.id +
        "&rp:ExecTime=" +
        currentTime +
        "&filterPaneEnabled=False&rdl:parameterPanel=hidden";

      let embedReportId = this.configuration.reportId835;
      let config = {
        type: "report",
        tokenType: pbi.models.TokenType.Aad,
        accessToken: token[0],
        embedUrl: embedUrl,
        id: embedReportId,
        settings: {},
        viewmode: pbi.models.ViewMode.View,
      };
      let reportContainer = this.reportContainer.nativeElement;
      let powerbi = new pbi.service.Service(
        pbi.factories.hpmFactory,
        pbi.factories.wpmpFactory,
        pbi.factories.routerFactory
      );
      let report = powerbi.embed(reportContainer, config);
      report.off("loaded");
      report.on("loaded", () => { });
    });
  }

}

